import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
} from '@mui/material';
import HighResPanel from './HighResPanel';

const HighResDialog = ({ open, onClose, t, settings, dispatch, highResFit, recommendPanel, onRunHighRes }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
    <DialogTitle>{t('estimationPage.highResDialogTitle') || 'High-resolution parameters'}</DialogTitle>
    <DialogContent>
      <HighResPanel
        settings={settings.highRes}
        onChange={{
          minGroupEvents: (event) => dispatch({ type: 'setHighRes', payload: { minGroupEvents: Math.max(0, Math.round(Number(event.target.value) || 0)) } }),
          minActiveYears: (event) => dispatch({ type: 'setHighRes', payload: { minActiveYears: Math.max(0, Math.round(Number(event.target.value) || 0)) } }),
          minSpanYears: (event) => dispatch({ type: 'setHighRes', payload: { minSpanYears: Math.max(0, Math.round(Number(event.target.value) || 0)) } }),
          poolLowQuality: (event) => dispatch({ type: 'setHighRes', payload: { poolLowQuality: event.target.checked } }),
          solowGuardEnabled: (event) => dispatch({ type: 'setHighRes', payload: { solowGuardEnabled: event.target.checked } }),
          solowMaxRatio: (event) => dispatch({ type: 'setHighRes', payload: { solowMaxRatio: Math.max(0, Number(event.target.value) || 0) } }),
          solowMinR2: (event) => dispatch({ type: 'setHighRes', payload: { solowMinR2: Math.max(0, Math.min(1, Number(event.target.value) || 0)) } }),
          curveGuardEnabled: (event) => dispatch({ type: 'setHighRes', payload: { curveGuardEnabled: event.target.checked } }),
          curveMinR2: (event) => dispatch({ type: 'setHighRes', payload: { curveMinR2: Math.max(0, Math.min(1, Number(event.target.value) || 0)) } }),
          highResComputeCI: (event) => dispatch({ type: 'setHighRes', payload: { highResComputeCI: event.target.checked } }),
          highResBootstrapSamples: (event) => dispatch({ type: 'setHighRes', payload: { highResBootstrapSamples: Math.max(0, Math.round(Number(event.target.value) || 0)) } }),
        }}
        disabledReason={highResFit.disabledReason}
        loading={highResFit.loading}
        error={highResFit.error}
        stage={highResFit.stage}
        progress={highResFit.progress}
        recommendPanel={recommendPanel}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>{t('estimationPage.highResDialogCancel') || 'Cancel'}</Button>
      <Button
        variant="contained"
        onClick={() => {
          if (typeof onRunHighRes === 'function') onRunHighRes();
          else if (typeof highResFit.run === 'function') highResFit.run();
          onClose();
        }}
        disabled={!highResFit.canRun || highResFit.loading}
      >
        {t('estimationPage.highResDialogRun') || 'Run high-res'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default HighResDialog;
